module.exports = __webpack_public_path__ + "img/bystyle@2x.b25836d.jpg";